import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import {ScheduledSpot as ScheduledSpotService} from "../../services/scheduledSpotService";
import {Image} from "react-bootstrap";
import spinner from "../../assets/td-emerald-loading-spinner-small.png";
import styles from "./RFQModal.scss";

// TODO Add a timeout? Yes, no cancel
export default function ScheduledSpotWaitingModal() {
    const { t } = useTranslation();
    const [scheduledSpotState, setScheduledSpotState] = useState(ScheduledSpotService.state);
    const waitingTitleKey = ScheduledSpotService.isCancellingScheduledSpot()
        ? 'td.fx.ticket.scheduledspot.cancel.waiting.title'
        : 'td.fx.ticket.scheduledspot.waiting.title';

    useEffect(() => {
        let done = false;
        let sub = ScheduledSpotService.subscribe(() => {
            if (!done) {
                setScheduledSpotState(ScheduledSpotService.state);
            }
        });
        return (() => {
            done = true;
            ScheduledSpotService.unsubscribe(sub);
        });
    }, []);

    return (
        <Modal show={ScheduledSpotService.isWaitingForScheduledSpot()} centered className="td-modal">
            <Modal.Header className={styles.noflex}>
                <Modal.Title>
                    <h2>{t(waitingTitleKey)}</h2> <Image src={spinner} style={{ width: '40px', paddingLeft: '10px' }}/>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            </Modal.Body>
        </Modal>
    );
}

